const ErrorPage = ({ children }) => {
    const handleClick = () => {
        window.location.href = "/";
    };

    return (
        <div className="w-full h-screen p-6 bg-gg-cream">
            <div className="mx-auto max-w-prose p-6 space-y-4">
                <h2 className='font-gg-heading text-xl text-gg-dark uppercase mb-2'>Something went wrong</h2>
                <p>
                    An unexpected error occurred.
                </p>
                <button
                    type="button"
                    onClick={handleClick}
                    className="flex items-center justify-between bg-gg-green rounded-md px-6 py-3 font-gg-heading text-white text-lg uppercase"
                >
                    Restart App
                </button>
                {children}
            </div>
        </div>

    )
}

export default ErrorPage;